import React, { useEffect, useContext, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Form, Input, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useValidateInfo } from 'all-in-one-shared-api';
// import { InfoCircleOutlined } from '@ant-design/icons';

// import forgotIcon from 'assets/images/reset-icon.svg';
// import { VStack } from "components";
// import { loginIdRegex } from 'utils/regex';
import generateKey from 'utils/generateKey';

import { ForgotPasswordData } from './forgotPasswordData';
import PolicyAndMemberIdModal from './PolicyAndMemberIdModal';
// import { Wrapper } from './styledComponents';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { ActionType, RegistrationFlowContext, RegistrationFormData } from 'contexts/registration';
import { MobileNumberPrefix } from 'components';
import { setErrorCodeFun } from '../../../utils/setErrorCodeFun/setErrorCodeFun';
import { newVerifyMobileNumber } from '../../../utils';
import { useMediaQuery } from 'react-responsive';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
function ForgotPasswordWithMobilePage() {
  const initialValues = useRegistrationStateQuery();
  const isLargeScreen = useMediaQuery({ minWidth: 768 });
  const { t, i18n } = useTranslation();
  const { state, dispatch } = useContext(RegistrationFlowContext);
  const [isLoading, setIsLoading] = useState(false);
  const [formDataState, setFormDataState] = React.useState<ForgotPasswordData>({
    mobile: '',
    countryCode: '',
  });
  const navigate = useNavigate();
  const [forgotPasswordWithLoginKey, setForgotPasswordWithLoginKey] = React.useState<string>('');
  // const [forgotPasswordWithMemberIdKey, setForgotPasswordWithMemberIdKey] = React.useState<string>('');
  const [snackbarMessage] = React.useState('');
  const [isShowError, setShowError] = React.useState(false);
  // const [method, setMethod] = React.useState('loginId');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [form] = Form.useForm();
  const [errmessage, setErrmessage] = useState<string | null>(null);
  const [errors, setErrors] = useState<string | null>(null);

  const errorMapping: Record<string, string> = {
    'auth.recovery.invalid': 'forgetLoginId.error.informationInvalid',
  };

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);

  // const onChange = (e: RadioChangeEvent) => {
  //   setMethod(e.target.value);
  // };
  const {
    shouldFetch: shouldValidateFetch,
    data: forgotPasswordWithLoginData,
    error: validateError,
  } = useValidateInfo(
    forgotPasswordWithLoginKey,
    state.selfDefinedLoginId || initialValues.selfDefinedLoginId || '',
    '',
    formDataState.mobile ?? '',
    formDataState.countryCode ?? '',
    'Y',
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      onSuccess: () => {
        setIsLoading(false);
        // setStartLoading(false);
      },
      onError: () => {
        setIsLoading(false);
        // setStartLoading(false);
        // const message = setErrorCodeFun(err.code, i18n.language);
      },
    },
  );

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  const closeModel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    console.log('forgotPasswordWithLoginData', forgotPasswordWithLoginData, forgotPasswordWithLoginData?.message);
    if (forgotPasswordWithLoginData && !validateError) {
      dispatch({
        type: ActionType.UpdateFormData,
        payload: { mobile: formDataState.mobile, countryCode: formDataState.countryCode },
      });
      navigate('/forgot/otp-verification', {
        replace: true,
        state: {
          loginId: state.selfDefinedLoginId || initialValues.selfDefinedLoginId,
          mobile: state.mobile || initialValues.mobile || '',
          email: state.email || initialValues.email || '',
          countryCode: state.countryCode || initialValues.countryCode || '',
          prevPath: location.pathname,
          type: forgotPasswordWithLoginData.message == 'EB' ? 'eb' : 'life',
        },
      });
    }
  }, [forgotPasswordWithLoginData, validateError, navigate, state, initialValues, dispatch, formDataState]);

  useEffect(() => {
    if (validateError && validateError.code) {
      shouldValidateFetch(false);
      setIsLoading(false);
      //   setLoading(false);
      setErrors(validateError.code);

      const errorMessage = setErrorCodeFun(validateError.code, i18n.language);
      console.log('error', validateError);
      setErrmessage(errorMessage ?? validateError.code ?? validateError.message);
    }
    if (i18n.language && errors) {
      const message = setErrorCodeFun(errors, i18n.language);
      setErrmessage(message ?? errors);
    }
  }, [validateError, shouldValidateFetch, i18n.language, errors]);

  const handleCloseSnackbar = () => {
    setShowError(false);
  };

  const onValidateSuccessful = React.useCallback(
    (data: RegistrationFormData, event?: React.BaseSyntheticEvent) => {
      event && event.preventDefault();
      dispatch({ type: ActionType.UpdateFormData, payload: data });
      setForgotPasswordWithLoginKey(generateKey);
      shouldValidateFetch(true);
      setIsLoading(true);
    },
    [dispatch, shouldValidateFetch],
  );

  const handleChange = useCallback(
    (value: string) => {
      form.setFieldsValue({
        countryCode: value,
      });
      setFormDataState((prevState) => {
        return { ...prevState, countryCode: value };
      });
      // dispatch({ type: ActionType.UpdateFormData, payload: { ...state, countryCode: value } });
      // eslint-disable-line react-hooks/exhaustive-deps
    },
    [form],
  );
  useEffect(() => {
    handleChange('+852');
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [handleChange]);
  const onFinish = () => {
    // navigate('/forgot/otp-verification', {
    //   state: {
    //     loginId: state.selfDefinedLoginId,
    //     mobile: state.mobile ?? '',
    //     countryCode: state.countryCode ?? '',
    //     prevPath: location.pathname,
    //   },
    // }); //提交时注释掉
    // setFormDataState({
    //   mobile: values.mobile,
    //   countryCode: values.countryCode,
    //   // email: values.email,
    //   // selfDefinedLoginId: values.selfDefinedLoginId,
    //   // memberId: values.memberId && values.memberId.toString(),
    //   // policyNumber: values.memberId && values.policyNumber.toString(),
    // });

    onValidateSuccessful(formDataState);
  };
  const isValid = formDataState.countryCode?.trim() !== '' && formDataState.mobile?.trim() !== '';

  // useEffect(() => {
  //   if (formDataState.mobile) {
  //     // 确保formDataState更新后才执行
  //     onValidateSuccessful(formDataState);
  //   }
  // }, [formDataState, onValidateSuccessful]);
  // const infoIcon = <InfoCircleOutlined onClick={showModal} style={{ cursor: 'pointer' }} />;

  return (
    <div
      className="forgot_wrapper"
      style={{
        paddingLeft: isLargeScreen ? '40px' : '0',
        paddingRight: isLargeScreen ? '40px' : '0',
      }}
    >
      {/* <img src={forgotIcon} alt="forgot-icon" style={{ marginBottom: 12 }} /> */}
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#fff', fontWeight: '400' }}
      >
        {t('life.forgetLoginId.ForgotPassword')}{' '}
      </Typography.Title>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          paddingBottom: '200px',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '0',
            border: '0',
            width: isLargeScreen ? '50%' : '100%', // 根据屏幕大小动态调整宽度
            padding: '20px',
          }}
        >
          {isShowError && (
            <Alert
              className="custom-alert"
              message={t(errorMapping[snackbarMessage])}
              type="error"
              closable
              onClose={handleCloseSnackbar}
              style={{
                marginBottom: 16,
                // backgroundColor: 'red',
                color: 'yellow',
              }}
            />
          )}

          {/* <VStack>
          <Typography.Text type="secondary">
            {t("forgetPassword.description")}
          </Typography.Text>
          <Space style={{ marginTop: 16, marginBottom: 16 }}>
            <Typography.Text>{t("forgetPassword.instruction")}</Typography.Text>
          </Space>
        </VStack> */}
          <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
            {' '}
            {t('forgetPassword.telDescription')}
          </Typography.Text>
          <Form
            layout={'vertical'}
            form={form}
            style={{ marginTop: 16 }}
            onFinish={onFinish}
            requiredMark="optional"
            validateTrigger={false}
            onChange={() => {
              // 获取当前所有字段的值
              const formValues = form.getFieldsValue();

              // 如果 selfDefinedLoginId 有变化，则更新 formDataState

              setFormDataState({ mobile: formValues.mobile, countryCode: formValues.countryCode });
            }}
            // onValuesChange={(changedValues) => {
            //   // Only update the formDataState when necessary
            //   setFormDataState((prevState) => ({
            //     ...prevState,
            //     ...changedValues,
            //   }));
            // }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                background: 'white',
              }}
            >
              {/* <Form.Item label={t('life.login.selfDefinedIdLabel')} name="countryCode" style={{ marginBottom: 12 }}>
                <Input
                  size="middle"
                  placeholder={t('life.forgetPassword.loginIdPlaceholder')}
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    // color: "white",
                    backgroundColor: 'transparent',
                  }}
                />
              </Form.Item> */}
              {/* <Form.Item name={'countryCode'}>
                <MobileNumberPrefix defaultValue="+852" handleChange={handleChange} />
              </Form.Item>
              <Form.Item
                label={
                  <span style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
                    {t('forgetPassword.telLabel')}
                  </span>
                }
                name="mobile"
                style={{ marginBottom: 12 }}
              >
                <Input
                  size="middle"
                  placeholder={t('forgetLoginId.mobileNumber')}
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    color: 'white',
                    paddingLeft: 0,
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    backgroundColor: 'transparent',
                  }}
                />
              </Form.Item> */}
              {/* <Form.Item
                label={t('life.forgetLoginId.MobileNumber')}
                name="mobileFiled"
                required
                className="mobile"
                style={{
                  marginBottom: 12,
                  display: 'flex',
                  flexDirection: 'row',
                  // background: 'red',
                  width: '100%',
                }}
              >
                <Form.Item name={'countryCode'}>
                  <MobileNumberPrefix defaultValue="+852" handleChange={handleChange} />
                </Form.Item>
                <Form.Item
                  name={'mobile'}
                  rules={[
                    {
                      required: true,
                      message: t('registration.error.required'),
                    },
                    {
                      validator: (_, value) => {
                        if (value && !newVerifyMobileNumber(formDataState.countryCode as string, value)) {
                          return Promise.reject(new Error(t('registration.error.invalidMobile')));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    size="middle"
                    placeholder={t('forgetLoginId.mobileNumber')}
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #E5E5E5',
                      width: '488px',
                      paddingLeft: 0,
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Form.Item>
              </Form.Item> */}
              <Form.Item
                label={
                  <div style={{ fontFamily: 'Roboto400', fontSize: '17px', color: '#6F7072' }}>
                    {t('life.forgetLoginId.MobileNumber')}
                  </div>
                }
                name="mobileFiled"
                required
                className="mobile custom-country-select"
                style={{
                  marginBottom: 12,
                  display: 'flex',
                  flexDirection: 'row',
                  background: 'white',
                  width: '100%',
                }}
              >
                <div className="countryCodestyle">
                  <Form.Item name="countryCode">
                    <MobileNumberPrefix defaultValue="+852" handleChange={handleChange} />
                  </Form.Item>
                </div>
                <div className="phonestyle" style={{ width: '500px', background: 'white', flex: 1 }}>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: t('registration.error.required'),
                      },
                      {
                        validator: (_, value) => {
                          if (value && !newVerifyMobileNumber(formDataState.countryCode as string, value)) {
                            return Promise.reject(new Error(t('registration.error.invalidMobile')));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    required
                    name="mobile"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.forgetLoginId.PhoneNumber')}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #CCCCCC',
                        // color: "white",
                        flex: 1,
                        backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        marginBottom: '10px',
                        padding: '4px 0',
                      }}
                    />
                  </Form.Item>
                </div>
              </Form.Item>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                // backgroundColor: 'pink',
              }}
            >
              <Form.Item style={{ width: '80%' }}>
                {errmessage && (
                  <Alert
                    className="custom-alert"
                    message={errmessage}
                    type="error"
                    style={{
                      marginTop: 16,
                      border: 'none',
                    }}
                  />
                )}
                <Button
                  block
                  type="primary"
                  loading={isLoading}
                  size="large"
                  htmlType="submit"
                  disabled={!isValid} // 禁用条件
                  style={{
                    marginTop: 24,
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    width: '100%',
                  }}
                >
                  {t('common.submit')}
                </Button>
              </Form.Item>
              {/* <Link
                style={{
                  fontWeight: 'normal',
                  marginLeft: 4,
                  marginRight: 4,
                  color: '#C21B17',
                  textDecoration: 'underline',
                }}
                to="/forgot/login"
                onClick={(e) => e.preventDefault()}
              >
                {t('forgetLoginId.help')}
              </Link> */}
            </div>
          </Form>
        </div>
        <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
      </div>
    </div>
  );
}

export default ForgotPasswordWithMobilePage;
